import React, { useContext, useEffect } from "react";
import { ClassTypeContext } from "../../context/ClassTypesContext";
import ClassTypesCarousel from "../classTypes/ClassTypesCarousel";

const MonterreyLandingClassTypes = ({
  fromPartners = false,
  title,
  subtitle,
  description,
  hideButton = false,
  classTypeIds,
  branch_id,
}) => {
  const { class_types, getClassTypes } = useContext(ClassTypeContext);

  useEffect(() => {
    getClassTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id="scrollspyMtyClassTypes"
      className={`container-fluid mt-5 ${fromPartners ? "pb-5 partners-class-types" : " monterrey-landing-class-types"}`}
    >
      <div className="row w-100 mx-auto">
        <p className="h2 p-0 text-capitalize bold">
          {title || "Everything you want in a workout"}
        </p>
        <p className="monterrey-landing-class-types__subtitle p-0">
          {subtitle ||
            "Disfruta de nuestro método combinando diferentes disciplinas, clases de FUERZA, CARDIO, BARRE & PILATES"}
        </p>

        <p className="monterrey-landing-class-types__description bold text-black p-0">
          {description ||
            "¡Conoce los beneficios de cada una de nuestras clases!"}
        </p>
      </div>

      <div className="container-fluid px-0 pe-md-3">
        <ClassTypesCarousel
          hideButton={hideButton}
          branch_id={branch_id}
          imageOverrides={
            fromPartners
              ? {
                  1: "/img/barre-partners.PNG",
                  7: "/img/sculpt-partners.PNG",
                  27: "/img/bbp-partners.PNG",
                }
              : undefined
          }
          descriptionOverrides={
            fromPartners
              ? {
                  1: "Barre combina elementos de ballet, pilates y body sculpt para trabajar el cuerpo completo con repeticiones, micro movimientos y elongaciones. El resultado: un cuerpo más tonificado, fuerte y estilizado, con mayor postura, estabilidad y alineación. Es una clase retadora, de bajo impacto, trabajo profundo y resultados visibles.",
                  7: "Sculpt and Burn (SNB) es una clase de fuerza diseñada para desarrollar masa muscular y lograr un cuerpo fuerte, definido y funcional. Combina ejercicios funcionales y específicos con peso añadido, dentro de una estructura de rutina diseñada para mejorar tu fuerza, resistencia muscular y control postural.",
                  27: "Block Burn Pilates (BBP) fusiona pilates clásico con ballet y fuerza utilizando un par de blocks de corcho como herramienta principal. Al trabajar sobre una superficie inestable, aumentas la activación muscular, mejoras tu control, equilibrio y coordinación, y fortaleces el cuerpo desde ángulos retadores y poco comunes para lograr definición, tono y fuerza. Es una práctica intensa que conecta mente y cuerpo, desarrollando conciencia corporal para llevarla también a tu día a día.",
                }
              : undefined
          }
          class_types={class_types
            ?.filter((class_type) => class_type.branch_id === branch_id)
            .filter(({ file }) => file !== null)
            .filter(
              (class_type) =>
                !classTypeIds?.length ||
                classTypeIds.includes(class_type.class_type_id),
            )
            .filter(({ class_type_id }) => ![8, 9, 43].includes(class_type_id))} // Exclude Barre 30, Sculpt 30, and Barre Express}
        />
      </div>
    </div>
  );
};

export default MonterreyLandingClassTypes;
